import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=67f2a4cc&scoped=true&"
import script from "./Introduction.vue?vue&type=script&lang=js&"
export * from "./Introduction.vue?vue&type=script&lang=js&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=67f2a4cc&prod&scoped=true&lang=css&"
import style1 from "./Introduction.vue?vue&type=style&index=1&id=67f2a4cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2a4cc",
  null
  
)

export default component.exports